<template>
  <div class="send-message-content d-flex justify-content-center align-items-center py-2">
    <div class="send-message-content" @drop="drop($event)" @dragover="dragover($event)" @dragleave="dragleave($event)">
      <textarea id="text-talk-input" class="send-message-content-textarea w-100 border shadow p-1" :value="value" @input="doInput($event)" />
    </div>
  </div>
</template>
  
<script>
export default {
  name: "TextTalkInput",
  props: {
    value: {
      type: String,
      required: true,
    },
    setHandler: {
      type: Function,
      default: () => {},
    },
    setErrorValidateTalkFile: {
      type: Function,
      default: () => {},
    },
  },
  emits: ['dropFile'],
  methods: {
    doInput(event) {
      this.setHandler(event.target);
    },
    dragover(event) {
      event.preventDefault();
    },
    dragleave(event) {
      event.preventDefault();
    },
    drop(event) {
      event.preventDefault();
      if(!event.dataTransfer.files?.length) return;
      if (event.dataTransfer.files?.length > 1) {
        this.setErrorValidateTalkFile('ファイルは１つだけ選択してください。');
      } else {
        this.$emit('dropFile', event.dataTransfer.files[0]);
      }
    },
  },
}
</script>
<style scoped>
.send-message-content {
  flex: 1;
}
.send-message-content > textarea {
  resize: none;
}
</style>
